import * as React from 'react';

import {setBodyId} from '../../../dom';
import {BannerCueCards} from '../../../ui/glossary/layout/banner-cue-cards';
import {PageContainer, PageTitleBar} from '../../../ui/layout';
import {mountSettingsSidebar} from '../../../ui/setup/mount-settings-sidebar';
import {mountQuotasNoTeamsBanner} from '../../../ui/setup/quotas/mount-quotas-no-teams-banner';
import {SetupPage} from '../../../ui/setup/setup-page';

type Props = {
    search: string;
    pathname: string;
};
/**
 * Wrapper for the sender addresses page that allows it to render as a complete
 * page outside of the setup context. We use this for the version in the marketing tab
 */
export function SalesQuotasPageStandalone(props: Props) {
    setBodyId('quota-manager');

    const glossaryKey = '/setup/quota';

    return (
        <PageContainer
            noPadding={true}
            title='Sales quotas'
            pageTitleBar={
                <PageTitleBar
                    title='Sales quotas'
                    subheaderPrimaryText='Distribute your sales quotas throughout the year and amongst your team members.'
                />
            }
        >
            {NutClientConfig.hasQuotasV2FF && !NutClientConfig.hasMigratedToQuotasV2 && (
                <div className='pt-16 px-16'>
                    <BannerCueCards glossaryKey={glossaryKey} />
                </div>
            )}
            <SetupPage
                pageTitle='Sales quotas'
                viewUrl={props.pathname}
                viewParams={props.search}
                onViewRendered={() => {
                    mountSettingsSidebar(glossaryKey);
                    mountQuotasNoTeamsBanner();
                }}
            />
        </PageContainer>
    );
}
